import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  basesDetail: {},
  customersDetail: {},
  sessionsDetail: {},
  invoicesList: [],
  subscriptionsList: [],
  sourcesList: [],
  statesList: [],
  ...stateAbstract
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
